// 2026-08-26 (Davids Drop 07e0f77, vendor f643ca1): Symmetrie-Gruppen der
// Presets ueberarbeitet — Werte (edges/t/angles/symmetry) 1:1 von David,
// nur unsere deutschen Namen behalten. Kernpunkte seiner Neuordnung:
//   * Jedes SPIEGELPAAR ist jetzt eine eigene Gruppe (z.B. 22/22 vorher
//     zwei Gruppen fuer 8 Masten, jetzt [1,-2,2,-1] — Eck- und Innenmast
//     duerfen unterschiedliche Leuchte/Tilt/Rotation tragen).
//   * Mittelmasten zielen mit 0 Grad senkrecht aufs Feld (222/121: vorher
//     +-5 bzw. +-22.5).
//   * Mittige DOPPELMASTEN stehen auf t=0.495/0.505 statt beide auf 0.5 —
//     zwei echte Positionen statt zweier deckungsgleicher Punkte.
// Backend-Seite: num_unique_masts = len(set(abs(symmetry))) traegt die
// groesseren Gruppenzahlen automatisch (mehr Gene je Chromosom).
export const mastLayouts = [
  {
    id: "layout_111_111",
    name: "6 Masten · 1·1·1",
    description: "1 1 1\n1 1 1",
    img: "/images/111_111.png",
    edges: [0, 0, 0, 2, 2, 2],
    t: [0.0, 0.5, 1.0, 0.0, 0.5, 1.0],
    angles: [45, 0, -45, 45, 0, -45],
    symmetry: [1, 0, -1, 1, 0, -1],
  },
  {
    id: "layout_222_222",
    name: "6 Masten · 2·2·2",
    description: "2 2 2\n2 2 2",
    img: "/images/222_222.png",
    edges: [0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2],
    t: [0.0, 0.0, 0.495, 0.505, 1.0, 1.0, 0.0, 0.0, 0.495, 0.505, 1.0, 1.0],
    angles: [67.5, 22.5, 0, -0, -22.5, -67.5, 67.5, 22.5, 0, -0, -22.5, -67.5],
    symmetry: [1, -2, 3, -3, 2, -1, 1, -2, 3, -3, 2, -1],
  },
  {
    id: "layout_02220_02220",
    name: "6 Masten · 0·2·2·2·0",
    description: "0 2 2 2 0\n0 2 2 2 0",
    img: "/images/02220_02220.png",
    edges: [0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2],
    t: [0.25, 0.25, 0.5, 0.5, 0.75, 0.75, 0.25, 0.25, 0.5, 0.5, 0.75, 0.75],
    angles: [45, -45, 45, -45, 45, -45, 45, -45, 45, -45, 45, -45],
    symmetry: [1, -2, 3, -3, 2, -1, 1, -2, 3, -3, 2, -1],
  },
  {
    id: "layout_212_212",
    name: "6 Masten · 2·1·2",
    description: "2 1 2\n2 1 2",
    img: "/images/212_212.png",
    edges: [0, 0, 0, 0, 0, 2, 2, 2, 2, 2],
    t: [0.0, 0.0, 0.5, 1.0, 1.0, 0.0, 0.0, 0.5, 1.0, 1.0],
    angles: [67.5, 22.5, 0, -22.5, -67.5, 67.5, 22.5, 0, -22.5, -67.5],
    symmetry: [1, -2, 0, 2, -1, 1, -2, 0, 2, -1],
  },
  {
    id: "layout_121_121",
    name: "6 Masten · 1·2·1",
    description: "1 2 1\n1 2 1",
    img: "/images/121_121.png",
    edges: [0, 0, 0, 0, 2, 2, 2, 2],
    t: [0.0, 0.495, 0.505, 1.0, 0.0, 0.495, 0.505, 1.0],
    angles: [45, -0.0, 0.0, -45, 45, 0.0, -0.0, -45],
    symmetry: [1, -2, 2, -1, 1, -2, 2, -1],
  },
  {
    id: "layout_11_11",
    name: "4 Masten · 1·1",
    description: "1 1\n1 1",
    img: "/images/11_11.png",
    edges: [0, 0, 2, 2],
    t: [0.0, 1.0, 0.0, 1.0],
    angles: [45, -45, 45, -45],
    symmetry: [1, -1, 1, -1],
  },
  {
    id: "layout_0220_0220",
    name: "4 Masten · 0·2·2·0",
    description: "0 2 2 0\n0 2 2 0",
    img: "/images/0220_0220.png",
    edges: [0, 0, 0, 0, 2, 2, 2, 2],
    t: [0.25, 0.25, 0.75, 0.75, 0.25, 0.25, 0.75, 0.75],
    angles: [45, -45, 45, -45, 45, -45, 45, -45],
    symmetry: [1, -2, 2, -1, 1, -2, 2, -1],
  },
  {
    id: "layout_22_22",
    name: "4 Masten · 2·2",
    description: "2 2\n2 2",
    img: "/images/22_22.png",
    edges: [0, 0, 0, 0, 2, 2, 2, 2],
    t: [0.0, 0.0, 1.0, 1.0, 0.0, 0.0, 1.0, 1.0],
    angles: [67.5, 22.5, -22.5, -67.5, 67.5, 22.5, -22.5, -67.5],
    symmetry: [1, -2, 2, -1, 1, -2, 2, -1],
  },
  {
    id: "layout_33_33",
    name: "4 Masten · 3·3",
    description: "3 3\n3 3",
    img: "/images/33_33.png",
    edges: [0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2],
    t: [0.0, 0.0, 0.0, 1.0, 1.0, 1.0, 0.0, 0.0, 0.0, 1.0, 1.0, 1.0],
    angles: [22.5, 45.0, 67.5, -22.5, -45.0, -67.5, 22.5, 45.0, 67.5, -22.5, -45.0, -67.5],
    symmetry: [1, 2, 3, -1, -2, -3, 1, 2, 3, -1, -2, -3],
  },
];
